import config from 'constants/config'
import { isEnabledForFeature } from 'lib/featureFlagUtils'

export function isTaxExclusiveForRegion(countryCode: string): boolean {
  return isEnabledForFeature(config.USE_EXCLUSIVE_PRICE_REGIONS, countryCode)
}
